import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineLite } from "gsap"; // Also works with TweenLite and TimelineLite: import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
// import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineLite);

const { Controller, Scene } = ScrollMagic;
const controller = new Controller({
	globalSceneOptions: {
		triggerHook: 0.85,
		// duration: "200%" // this works just fine with duration 0 as well
		// However with large numbers (>20) of pinned sections display errors can occur so every section should be unpinned once it's covered by the next section.
		// Normally 100% would work for this, but here 200% is used, as Panel 3 is shown for more than 100% of scrollheight due to the pause.
	},
});

const ScrollAnimation = {
	init: () => {
		const scrollAnimates = document.querySelectorAll(
			".scroll-animate"
		) as NodeListOf<HTMLElement>;

		scrollAnimates.forEach((element, index) => {
			const scrollTrigger = element.querySelector(
				".scroll-trigger"
			) as HTMLElement;
			const scrollTarget = element.querySelector(
				".scroll-target"
			) as HTMLElement;
			const { tween } = scrollTarget.dataset;
			let parsedTween = {};

			if (typeof tween !== "undefined") {
				parsedTween = JSON.parse(tween);
			}

			new Scene({
				triggerElement: scrollTrigger,
			})
				// .setTween(element, 0.5, parsedTween)
				.setClassToggle(scrollTarget, "animate").addIndicators!({
					name: `${index} (duration: 0)`,
				}).addTo(controller);
		});
	},

	loop: () => { },
};

export default ScrollAnimation;
